module.exports = __webpack_public_path__ + "static/media/b&w.eebb320d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/DevicePreview/b&w.gif
// module id = 1503
// module chunks = 0